<template>
  <div class="field-map-editor">
    <div class="tip" v-if="!sheetId">
      <div>请先选择工作表</div>
    </div>
    <template v-else>
      <tab :tab-list="tabs" @click="tabChange" :default-active="curRemoteSheetId"></tab>
      <div class="field-tip" v-if="!remoteLocalSheetIdMap[curRemoteSheetId]">
        <span style="color: #888888">
          请填写完整此表单依赖的控件({{ relyRefControlInfo }})后,
          <br />
          再填写此表的关联关系
        </span>
      </div>
      <el-tree
        v-else
        :data="treeData"
        :props="{ children: 'subList', label: 'name' }"
        node-key="cid"
        :expand-on-click-node="false"
      >
        <div class="row" slot-scope="{ node, data }">
          <template v-if="ruleMaster.export">
            <span v-tip class="label">
              <span v-if="data.required" style="color: red">*</span>
              {{ node.label }}
            </span>
            <span class="arrow">-></span>
          </template>
          <el-select
            :ref="'select'"
            :value="getValue(data)"
            @input="setValue(data, $event)"
            clearable
          >
            <el-option
              v-for="c in candidateControls(data)"
              :key="c._cid"
              :label="c.label"
              :value="c._cid"
            ></el-option>
          </el-select>
          <template v-if="!ruleMaster.export">
            <span class="arrow">-></span>
            <span v-tip class="label">
              <span v-if="data.required" style="color: red">*</span>
              {{ node.label }}
            </span>
          </template>
        </div>
      </el-tree>
    </template>
  </div>
</template>
<script>
import { getAllDefaultControls } from "@/api/sheet/sheet"
import { disabledFieldTypes, transFieldControl } from "@/utils/sheet"
import Tab from "@/components/UIComponents/Tab"
import { bfs } from "@/utils/algorithm"

export default {
  name: "field-map-editor",
  components: { Tab },
  props: {
    value: {
      type: Array,
      default: () => [
        // {
        //   localCid: "",
        //   remoteCid: "",
        //   optionMap: {}
        // }
      ]
    },
    sheetId: String, // 当前sheet
    sheetMap: Object,
    ruleMaster: Object
  },
  computed: {
    remoteLocalSheetIdMap() {
      let map = {
        [this.ruleMaster.sheetId]: this.sheetId
      }
      this.value
        .filter(val => val.localCid && this.controlMap[val.remoteCid]?._type === "ref")
        .forEach(val => {
          map[this.controlMap[val.remoteCid].refSheetId] = this.controlMap[val.localCid]?.refSheetId
        })
      return map
    },
    sheetFieldsTabMap() {
      let sheetFieldsTabMap = {}
      bfs({
        arr: this.ruleMaster.rows,
        childFuc: field => field.subList,
        cbk: field => {
          let sheetId = field._parent
            ? this.controlMap[field._parent.cid]?.refSheetId
            : this.ruleMaster.sheetId
          if (sheetId) {
            let fields = sheetFieldsTabMap[sheetId] || []
            let curField = fields.find(f => f.cid === field.cid)
            if (curField) {
              curField.cid = field.cid
              curField.required = curField.required || field.type === "H"
            } else {
              curField = { cid: field.cid, required: field.type === "H" }
              fields.push(curField)
            }
            sheetFieldsTabMap[sheetId] = fields
          }
        }
      })
      return sheetFieldsTabMap
    },
    relyRefControlInfo() {
      for (const remoteSheetId in this.sheetFieldsTabMap) {
        let fields = this.sheetFieldsTabMap[remoteSheetId]
        let field = fields.find(
          field => this.controlMap[field.cid].refSheetId === this.curRemoteSheetId
        )
        if (field) {
          return `工作表:[${this.sheetMap[remoteSheetId].name}],字段:[${
            this.controlMap[field.cid].name
          }]`
        }
      }
      return ""
    },
    tabs() {
      return Object.keys(this.sheetFieldsTabMap).map(sheetId => ({
        label: this.sheetMap[sheetId]?.name || "未知",
        value: sheetId
      }))
    },
    treeData() {
      let fields = this.sheetFieldsTabMap[this.curRemoteSheetId] || []
      return this.fillData(fields)
    },
    controlMap() {
      return this._.chain(this.sheetMap)
        .values()
        .map("controls")
        .flatten()
        .map(c => transFieldControl(c))
        .keyBy("_cid")
        .value()
    }
  },
  data() {
    return {
      controlTypeMap: {},
      curRemoteSheetId: this.ruleMaster.sheetId
    }
  },
  created() {
    getAllDefaultControls().then(res => (this.controlTypeMap = this._.keyBy(res, "_type")))
  },
  methods: {
    tabChange(tabValue) {
      this.curRemoteSheetId = tabValue
    },
    getValue({ cid, control, parentControl }) {
      // 选项字段特殊处理
      if (parentControl?._type === "option") {
        return this.value.find(t => t.remoteCid === parentControl._cid)?.optionMap?.[cid]
      }
      if (!control) {
        return ""
      }
      return this.value.find(t => t.remoteCid === control._cid)?.localCid
    },
    setValue({ cid, control, parentControl }, localCid) {
      let newValue = this._.cloneDeep(this.value)
      // 选项字段特殊处理
      if (parentControl?._type === "option") {
        // 默认一定能找得到
        newValue.find(t => t.remoteCid === parentControl._cid).optionMap[cid] = localCid
        this.emitValue(newValue)
        return
      }

      let t = newValue.find(t => t.remoteCid === control._cid)
      if (t) {
        t.localCid = localCid
        t.optionMap = {}
      } else {
        newValue.push({
          localCid: localCid,
          remoteCid: control._cid,
          optionMap: {}
        })
      }
      this.emitValue(newValue)
    },
    candidateControls({ cid, control, parentControl }) {
      // 选项字段特殊处理
      if (parentControl?._type === "option") {
        return this.controlMap[
          this.value.find(t => t.remoteCid === parentControl._cid)?.localCid
        ]?.options.map(option => ({
          _cid: option.value,
          label: option.value
        }))
      }

      if (!control) return []

      // 找到当前控件对应的工作表
      let sheetId = this.remoteLocalSheetIdMap[this.curRemoteSheetId]

      // 筛选此工作表内尚未被使用的字段(排除当前控件选择的字段)
      let res = (this.sheetMap?.[sheetId]?.controls || []).filter(
        c => !this.value.find(t => t.remoteCid !== control._cid && t.localCid === c._cid)
      )

      if (["string", "number"].includes(control._dataType)) {
        res = res.filter(c => c._dataType === control._dataType)
      } else if (control._type === "ref") {
        res = res
          .filter(c => c._type === "ref" && c.oneFlag === control.oneFlag)
          .filter(c => {
            let localSheetId = this.remoteLocalSheetIdMap[control.refSheetId]
            // 如果当前已经有其他关联控件设置关联了本地的工作表,则localSheetId不为空,
            // 对于剩下的其他关联同一个远端表的控件,要选择本地关联同一个表关联控件
            // (说人话就是,保证远端的工作表和本地的工作表一一对应)
            return localSheetId ? c.refSheetId === localSheetId : true
          })
      } else {
        res = res.filter(c => c._type === control._type && c.oneFlag === control.oneFlag)
      }

      if (this.ruleMaster.export) {
        res = res.filter(c => !disabledFieldTypes.includes(c._type))
      }

      // 手动删除非法值(当清除或者切换关联表类型的字段时,子字段已设置的值需要手动清空)
      let curVal = this.value.find(t => t.remoteCid === control._cid)?.localCid
      if (curVal && !res.find(c => c._cid === curVal)) {
        this.setValue({ control }, "")
      }

      return res.map(c => {
        const typeName = this.controlTypeMap?.[c._type]?.name
        let oneStr = c.oneFlag === undefined ? "" : `(${c.oneFlag ? "单" : "多"})`
        c.label = `[${typeName}${oneStr}] ${c.name}`
        return c
      })
    },
    fillData(rows, namePrefix = "") {
      rows.forEach(row => {
        const control = this.controlMap[row.cid]
        if (!control) return
        const typeName = this.controlTypeMap?.[control._type]?.name
        let oneStr = control.oneFlag === undefined ? "" : `(${control.oneFlag ? "单" : "多"})`
        row.name = `[${control.isRef ? "_" : ""}${typeName}${oneStr}] ${namePrefix}${control.name}`
        row.control = control
        if (control._type === "option") {
          row.subList = control.options.map(option => ({
            cid: option.value,
            name: option.value,
            parentControl: control
          }))
        }
      })
      return rows
    },
    emitValue(value) {
      this.$emit("input", value)
    },
    isAllFilled() {
      // 是否所有下拉框都已填充
      return !Array.from(this.$el.querySelectorAll(".el-select")).find(dom => !dom.__vue__.value)
    }
  }
}
</script>
<style scoped lang="scss">
.field-map-editor {
  ::v-deep {
    .el-tree-node {
      &:focus .el-tree-node__content {
        background-color: unset;
      }
      .el-tree-node__content {
        height: 35px;
        margin-bottom: 10px;
        &:hover {
          background-color: unset;
        }
      }
    }
  }
  .tab {
    margin-left: 26px;
    margin-bottom: 2px;
  }
  .field-tip {
    margin-left: 26px;
    line-height: 18px;
  }
  .tip {
    margin-left: 24px;
    flex: 1;
    height: 36px;
    line-height: 36px;
    background: #f8f8f8;
    border-radius: 4px;
    padding: 0 17px;
    box-sizing: border-box;
    color: #c0c4cc;
  }
  .row {
    display: flex;
    align-items: center;
    flex: 1;
    overflow: hidden;
    .label {
      flex: 1;
      background: #f8f8f8;
      border-radius: 10px;
      padding: 0 15px;
    }
    .el-checkbox {
      width: 60px;
      margin-left: 10px;
      padding: 0 10px;
      background: #f8f8f8;
      border-radius: 10px;
    }
    .el-button {
      width: 30px;
      margin-left: 10px;
    }
    .arrow {
      cursor: auto;
      width: 30px;
      text-align: center;
    }
  }
}
</style>
